// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__YFWW0","cta__canvas":"CTA_cta__canvas__FoL7b","cta_main":"CTA_cta_main__UWXoP","cta_primary":"CTA_cta_primary__KTnFh","cta__inner":"CTA_cta__inner__0Ah3H"};